enum TlbsRenewalTypeEnum {
	Alumni,
	Eofy,
}

export { TlbsRenewalTypeEnum };